import v from 'validator'
import moment from 'moment'

function validate(form, productNames) {
    let errors = []
    if (v.isEmpty(form.productName)) {
        errors.push('podaj nazwę produktu')
    }
    if (productNames.indexOf(form.productName) === -1) {
        errors.push('wybierz nazwę produktu z listy')
    }
    if (v.isEmpty(form.contactPhone)) {
        errors.push('podaj telefon kontaktowy')
    }
    if (v.isEmpty(form.description)) {
        errors.push('podaj opis')
    }
    let isBefore = moment(form.createdAt).isBefore(moment())
    if (!isBefore) {
        errors.push('data przyjęcia nie może być późniejsza od dnia dzisiejszego')
    }
    for (var i in form.historyItems) {
        var item = form.historyItems[i]
        let isBeforeItem = moment(item.createdAt).isBefore(moment())
        if (!isBeforeItem) {
            errors.push('data historii nie może być późniejsza od dnia dzisiejszego')
        }
        if (v.isEmpty(item.description)) {
            errors.push('opis historii kontaktu nie może być pusty')
        }
    }
    return [...new Set(errors)]
}

export default {
    "validate": validate
}


// WEBPACK FOOTER //
// ./src/components/complaints/Validator.js